import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Budget, BudgetSummary } from '../../store/reselectors/budget.data';
import { OnInit } from '@angular/core';
import { getNumberFromText } from '../../helpers/helpers';
import { allCashFlowColumns, cashFlowColumns, CashFlowGridData } from './../../helpers/grid-helpers';
import { EventStatus } from 'globals/store/events.data';
import { DropdownOption } from 'globals/store/programs.data';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { CommonModule } from '@angular/common';
import { BudgetGridComponent } from './budget-grid.component';
import { ArcComponent } from './arc.component';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';

type TaxChoice = 'exclusive' | 'inclusive'

@Component({
    selector: 'budget-report-view',
    templateUrl: './budget-report-view.html',
    styleUrls: ['../../page.scss', './budget-report-view.scss', './budget-totals.scss'],
    standalone: true,
    imports: [JoiInputComponent, FindByIdPipe, ArcComponent, PrettyNumbersPipe, DropdownComponent, CommonModule, BudgetGridComponent],
})
export class BudgetReportViewComponent implements OnInit {
  @Input() budget: Budget
  @Input() eventStatus: EventStatus
  @Input() readOnly: boolean
  @Input() budgetSummary: BudgetSummary
  @Input() cashFlowGrid: CashFlowGridData[]
  cashFlowColumns = allCashFlowColumns

  taxOptions: DropdownOption<TaxChoice>[] = [
    { id: 'exclusive', title: 'Tax exclusive' },
    { id: 'inclusive', title: 'Tax inclusive' }
  ]

  @Output() budgetUpdated: EventEmitter<void> = new EventEmitter()

  ngOnInit() {}
  
  updateTaxOption(taxChoice: TaxChoice) {
    this.budget.summaryTaxInclusive = taxChoice === 'inclusive'
    this.budgetUpdated.emit()
  }

  updateAttendees() {
    this.budget.attendees = getNumberFromText(this.budget.attendees, 0)
    this.budgetUpdated.emit()
  }

  updateOtherRevenue() {
    this.budget.otherRevenues[0].amount = getNumberFromText(this.budget.otherRevenues[0].amount, null)
    this.budgetUpdated.emit()
  }

}